import React from 'react';
import GenericModal from '../GenericModal';
import IcmsDebitosPeriodoDrillDownContent from './IcmsDebitosPeriodoDrillDownContent';
import { ProductDrillDownSkeleton } from '../Skeletons/ModalSkeletons';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: any | null;
  loading: boolean;
  error: string | null;
  selectedPeriodo: { periodo?: string; sped_fiscal_id?: number | string } | null;
  onRetry: () => void;
}

const IcmsDebitosPeriodoDrillDownModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  data,
  loading,
  error,
  selectedPeriodo,
  onRetry
}) => {
  return (
    <GenericModal
      open={isOpen}
      onClose={onClose}
      title={`Detalhamento de Débitos de ICMS – ${selectedPeriodo?.periodo || ''}`}
      loading={false}
      maxWidth="lg"
      fullWidth
    >
      {loading ? (
        <ProductDrillDownSkeleton />
      ) : error ? (
        <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>
      ) : (
        data && <IcmsDebitosPeriodoDrillDownContent data={data} />
      )}
    </GenericModal>
  );
};

export default IcmsDebitosPeriodoDrillDownModal; 